import { type VFC } from "react";
import { useSelector } from "react-redux";
import { CardGridArea } from "widgets";

import { renderSampleParentAttributesWidgets } from "@/app-utils/attributes-widgets.tsx";
import { type IParentState } from "@/redux/modules/parent.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { ENTITY_TYPE } from "@/settings/settings.js";

import { AttributesListWidget } from "../core/navigation-panel/AttributeWidget.js";
import { SampleParentsCard } from "./cards/SampleParentsCard.js";
import GenericEntitySummaryView from "./GenericEntitySummaryView.js";

const SampleParentSummaryView: VFC = () => {
  const { parent, isLoading } = useSelector<IAppState, IParentState>((state) => state.parent);
  const showSpinner = isLoading || !parent;
  const dynamicTitle = parent?.parentType != null ? parent.parentType.name : "";

  return (
    <GenericEntitySummaryView
      key={"GenericEntitySummaryView"}
      title={parent?.name ?? ""}
      subtitle={`${dynamicTitle} Summary`}
      entity={{ id: parent?.id, groupType: ENTITY_TYPE.SAMPLE_PARENT }}
      headerAttributes={[
        <AttributesListWidget
          attributes={renderSampleParentAttributesWidgets(parent)}
          key={"gene-expression-view-widget-1"}
        />,
      ]}
      isLoading={showSpinner}
      getEntityName={() => parent?.name}
      project={parent.project}
    >
      {parent && (
        <SampleParentsCard
          key={"svc-saa-" + parent.id}
          parent={parent}
          isEntitySummary={true}
          area={CardGridArea.Left}
        />
      )}
    </GenericEntitySummaryView>
  );
};

export { SampleParentSummaryView };
export default SampleParentSummaryView;
